module.exports = __webpack_public_path__ + "img/prf_pixelrealmtk.fe7ec32.png";